<template>
  <div>
    <div class="field w-full">
      <label
        for="dateFilterType"
        v-text="'Filter By Date(s)'"
      />
      <select
        id="dateFilterType"
        v-model="selectedScope"
        name="dateFilterType"
      >
        <option
          v-if="!schemaRequired"
          id="available-scope--none"
          value="none"
          v-text="'Include all dates'"
        />
        <option
          v-for="option in availableScopes"
          :id="`available-scope--${option}`"
          :key="`available-scope--${option}`"
          :value="option"
          v-text="formatTitle(option)"
        />
      </select>
    </div>
    <div class="flex-wrap flex justify-start">
      <div
        v-for="(dateInput, key) in schema[selectedScope]"
        :key="`scope-field-${key}`"
        class="w-2/5 mr-4"
      >
        <DateInput
          :label="key"
          @dateAdded="handleDateAdded"
        />
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
import { capitalize } from 'lodash'
import DateInput from './DateInput'
import displayNotifications from 'Base/Resources/assets/js/mixins/displays-notifications'
import FilterDescriptions from  'Membership/Resources/assets/js/mixins/filter-descriptions'

export default {
  name: 'DateFilter',
  components: {
    DateInput,
  },
  mixins: [displayNotifications, FilterDescriptions],
  props: {
    filter: {
      type: Object,
      required: true,
    },
    schema: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedScope: 'before',
      builtSchema: {},
    }
  },
  computed: {
    availableScopes() {
      return Object.keys(this.schema)
    },
    schemaRequired() {
      return this.filter.attributes.schema_required
    },
  },
  watch: {
    selectedScope() {
      this.builtSchema = {}

      this.$emit('schemaAdjusted', {
        filterId: this.filterId,
        schema: {},
      })
    },
  },
  methods: {
    handleDateAdded(payload) {
      this.builtSchema[payload.key] = payload.value

      const schema = {}

      schema[this.selectedScope] = this.builtSchema

      this.$emit('schemaAdjusted', {
        schema,
        description: this.buildDateFilterDescription(this.filter, schema),
      })
    },
    formatTitle(string) {
      return capitalize(string)
    },
  },
}
</script>
